import { useSelector } from 'react-redux';

const getApobSupplierId = () => {
  const { apobSupplierID, isIrnNeeded, isClearTaxInvoice } = useSelector((state) => {
    return state?.combinedSelectApobSeller?.selectApobSeller;
  });
  return { apobSupplierID, isIrnNeeded, isClearTaxInvoice };
};

export default getApobSupplierId;
